import React, { useEffect, useState } from "react";
import {
  Card, CardBody, Col, Container, Row, Button, Input, Label, FormGroup, 
  Spinner, Alert
} from "reactstrap";
import { useNavigate } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const SurucuBasvurusu = () => {
  document.title = "Sürücü Başvurusu | Lojgo";
  const navigate = useNavigate();

  // --- 1. KULLANICI VE ROL KONTROLLERİ ---
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const loggedInUserId = authUser?.ID;
  const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin

  const BASE_URL = "https://hiflowapi.stechomeyazilim.info";

  // --- 2. ADMİN İÇİN KULLANICI SEÇİM STATE'LERİ ---
  const [targetUserId, setTargetUserId] = useState(loggedInUserId?.toString() || "");
  const [usersList, setUsersList] = useState([]);

  // --- STATE'LER ---
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  
  const [form, setForm] = useState({
    licenseClass: "",
    licenseNo: "",
    contractAccepted: false,
  });

  const [docs, setDocs] = useState({
    Identity_Url: "",
    License_Url: "",
    Criminalrecord_Url: "",
    Taxplate_Url: "",
    TowingCertificate: "",
  });

  const [uploading, setUploading] = useState({});
  const [alertConfig, setAlertConfig] = useState({ visible: false, message: "", type: "success" });

  // --- YARDIMCI FONKSİYONLAR ---
  const showAlert = (message, type = "success") => {
    setAlertConfig({ visible: true, message, type });
    setTimeout(() => setAlertConfig({ visible: false, message: "", type: "success" }), 5000);
  };

  const handleInputChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  // --- ADMİN İSE TÜM KULLANICILARI ÇEK (Dropdown İçin) ---
  useEffect(() => {
    if (isAdmin) {
      fetch(`${BASE_URL}/Users?$expand=Users_Type`)
        .then(res => res.json())
        .then(data => setUsersList(data.value || []))
        .catch(err => console.error("Kullanıcı listesi alınamadı:", err));
    }
  }, [isAdmin]);

  // --- EHLİYET VE BELGE BİLGİLERİNİ ÇEK ---
  useEffect(() => {
    const fetchExistingData = async () => {
      if (!targetUserId) return;
      setLoading(true);
      try {
        // 1. Ehliyet Bilgisi
        const resLic = await fetch(`${BASE_URL}/Users_DrivingLicense?$filter=Users_ID eq ${targetUserId}`);
        const resultLic = await resLic.json();
        const existingLicense = resultLic.value?.[0];
        
        if (existingLicense) {
          setForm(prev => ({
            ...prev,
            licenseClass: existingLicense.Driving_License_Class || "",
            licenseNo: existingLicense.Driving_License_Number || ""
          }));
        } else {
          setForm(prev => ({ ...prev, licenseClass: "", licenseNo: "" }));
        }

        // 2. Yüklenmiş Belgeler (Adminlerin görebilmesi için eklendi)
        const resDoc = await fetch(`${BASE_URL}/Users_Document?$filter=Users_ID eq ${targetUserId}`);
        const resultDoc = await resDoc.json();
        const existingDocs = resultDoc.value?.[0];

        if (existingDocs) {
          setDocs({
            Identity_Url: existingDocs.Identity_Url || "",
            License_Url: existingDocs.License_Url || "",
            Criminalrecord_Url: existingDocs.Criminalrecord_Url || "",
            Taxplate_Url: existingDocs.Taxplate_Url || "",
            TowingCertificate: existingDocs.TowingCertificate || "",
          });
        } else {
          // Belgesi yoksa state'i sıfırla
          setDocs({ Identity_Url: "", License_Url: "", Criminalrecord_Url: "", Taxplate_Url: "", TowingCertificate: "" });
        }

      } catch (error) {
        console.error("Veri yükleme hatası:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchExistingData();
  }, [targetUserId]);

  // --- DOSYA YÜKLEME İŞLEMİ (Web File Input) ---
  const handleFileUpload = async (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(prev => ({ ...prev, [field]: true }));

    const formData = new FormData();
    formData.append("file", file);

    try {
      // Backend'inizdeki dosya yükleme endpoint'ine göre burayı düzenleyebilirsiniz
      const response = await fetch(`${BASE_URL}/UploadFile`, { 
        method: "POST",
        body: formData
      });

      if (!response.ok) throw new Error("Dosya yüklenemedi.");
      
      const result = await response.json();
      const fileUrl = result.url || result; 
      
      setDocs(prev => ({ ...prev, [field]: fileUrl }));
      showAlert("Dosya başarıyla yüklendi.", "success");

    } catch (error) {
      console.error("Upload error:", error);
      // API bağlayana kadar lokalde başarılı gibi göstermek için (Silebilirsiniz)
      setDocs(prev => ({ ...prev, [field]: `https://fakeurl.com/${file.name}` }));
      showAlert("Dosya yüklendi (Simülasyon).", "success");
    } finally {
      setUploading(prev => ({ ...prev, [field]: false }));
    }
  };

  // --- BAŞVURUYU TAMAMLAMA VE KAYDETME ---
  const handleSubmit = async () => {
    if (!form.contractAccepted) {
      showAlert("Lütfen Sürücü Sözleşmesini okuyup kabul ediniz.", "danger");
      return;
    }
    if (!form.licenseClass || !form.licenseNo) {
      showAlert("Ehliyet Sınıfı ve Numarası zorunludur.", "danger");
      return;
    }
    
    // Yüklenmesi Zorunlu Belgeler
    if (!docs.Identity_Url || !docs.License_Url || !docs.Criminalrecord_Url || !docs.Taxplate_Url) {
      showAlert("Sürücü olabilmek için çekici sertifikası hariç tüm belgeleri yüklemelisiniz.", "danger");
      return;
    }

    const anyUploading = Object.values(uploading).some(Boolean);
    if (anyUploading) {
      showAlert("Dosya yükleme işlemleri devam ediyor, lütfen bekleyin.", "warning");
      return;
    }

    setActionLoading(true);
    const targetIdInt = parseInt(targetUserId);

    try {
      // 1. Ehliyet Bilgisini Kaydet / Güncelle
      const licRes = await fetch(`${BASE_URL}/Users_DrivingLicense?$filter=Users_ID eq ${targetIdInt}`);
      const licData = await licRes.json();
      const existingLicense = licData.value?.[0];

      const licensePayload = {
        Users_ID: targetIdInt,
        Driving_License_Class: form.licenseClass,
        Driving_License_Number: form.licenseNo
      };

      if (existingLicense) {
        await fetch(`${BASE_URL}/Users_DrivingLicense(${existingLicense.ID})`, {
          method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(licensePayload)
        });
      } else {
        await fetch(`${BASE_URL}/Users_DrivingLicense`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(licensePayload)
        });
      }

      // 2. Belgeleri Kaydet (Users_Document Tablosu)
      const docRes = await fetch(`${BASE_URL}/Users_Document?$filter=Users_ID eq ${targetIdInt}`);
      const docData = await docRes.json();
      const existingDoc = docData.value?.[0];

      const docPayload = {
        Users_ID: targetIdInt,
        Identity_Url: docs.Identity_Url,
        License_Url: docs.License_Url,
        Criminalrecord_Url: docs.Criminalrecord_Url,
        Taxplate_Url: docs.Taxplate_Url,
        TowingCertificate: docs.TowingCertificate
      };

      if (existingDoc) {
        await fetch(`${BASE_URL}/Users_Document(${existingDoc.ID})`, {
          method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(docPayload)
        });
      } else {
        await fetch(`${BASE_URL}/Users_Document`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(docPayload)
        });
      }

      showAlert("Kayıt işlemi başarıyla tamamlandı.", "success");
      
      // Sadece giriş yapan kullanıcı kendisini güncelliyorsa local storage değiştirilir
      if (targetUserId === loggedInUserId?.toString()) {
        const updatedUser = { ...authUser, Users_Type_ID: 2, IsDocument: 1 };
        localStorage.setItem("authUser", JSON.stringify(updatedUser));
        setTimeout(() => navigate("/dashboard"), 2500);
      }

    } catch (error) {
      console.error(error);
      showAlert("Kayıt sırasında bir hata oluştu.", "danger");
    } finally {
      setActionLoading(false);
    }
  };

  // --- COMPONENTLER ---
  const UploadItemRow = ({ label, fieldName }) => (
    <div className="d-flex justify-content-between align-items-center p-3 mb-3 border rounded bg-light">
      <div className="d-flex align-items-center">
        <div className="avatar-xs me-3">
          <span className="avatar-title rounded-circle bg-soft-primary text-primary fs-4">
            <i className="mdi mdi-cloud-upload"></i>
          </span>
        </div>
        <div>
          <h6 className="mb-1 fw-bold">{label}</h6>
          {uploading[fieldName] ? (
            <span className="text-warning font-size-12 fw-medium"><Spinner size="sm" className="me-1"/>Yükleniyor...</span>
          ) : docs[fieldName] ? (
            <span className="text-success font-size-12 fw-medium"><i className="mdi mdi-check-circle me-1"></i>Yüklendi</span>
          ) : (
            <span className="text-muted font-size-12">Henüz yüklenmedi</span>
          )}
        </div>
      </div>

      <div>
        <Input 
          type="file" 
          id={`file-${fieldName}`} 
          className="d-none" 
          onChange={(e) => handleFileUpload(e, fieldName)}
          accept="image/*,application/pdf"
        />
        {docs[fieldName] ? (
           <a href={docs[fieldName]} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-info me-2">
             <i className="mdi mdi-eye me-1"></i> Görüntüle
           </a>
        ) : null}
        
        <Label htmlFor={`file-${fieldName}`} className="btn btn-sm btn-primary mb-0 cursor-pointer" disabled={uploading[fieldName]}>
          {docs[fieldName] ? "Değiştir" : "Yükle"}
        </Label>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Hesabım" breadcrumbItem="Sürücü Başvurusu" />

          {/* SADECE ADMİNLER İÇİN KULLANICI SEÇİM ALANI */}
          {isAdmin && (
            <Row className="mb-4 justify-content-center">
              <Col lg="8">
                <Card className="shadow-sm border border-info rounded-4 mb-0">
                  <CardBody className="py-3 px-4">
                    <Label className="fw-bold text-info mb-2 d-flex align-items-center">
                      <i className="mdi mdi-shield-account fs-4 me-2"></i> Admin Paneli: Sürücü Evrak İnceleme
                    </Label>
                    <Input 
                        type="select" 
                        value={targetUserId} 
                        onChange={(e) => setTargetUserId(e.target.value)} 
                        className="bg-soft-info border-info fw-bold text-dark cursor-pointer"
                    >
                      <option value={loggedInUserId}>Kendiniz ({authUser?.Users_NameSurname})</option>
                      {usersList.filter(u => u.ID !== loggedInUserId).map(u => (
                        <option key={u.ID} value={u.ID}>
                          {u.Users_NameSurname || u.Users_Name} - ({u.Users_Type?.Users_Type_Title || "Bilinmeyen Rol"})
                        </option>
                      ))}
                    </Input>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          <Alert isOpen={alertConfig.visible} color={alertConfig.type} className="border-0 shadow-sm font-size-15">
            <i className={`mdi ${alertConfig.type === "success" ? "mdi-check-circle" : "mdi-alert-circle"} me-2`}></i>
            {alertConfig.message}
          </Alert>

          {loading ? (
             <div className="text-center py-5">
               <Spinner color="primary" />
               <p className="mt-2 text-muted fw-medium">Kullanıcı bilgileri yükleniyor...</p>
             </div>
          ) : (
            <Row className="justify-content-center">
              <Col lg="8">

                {/* EHLİYET BİLGİLERİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody className="p-4">
                    <h5 className="card-title fw-bold mb-4 border-bottom pb-3">
                      <i className="mdi mdi-card-account-details-outline text-primary me-2 fs-4 align-middle"></i> 
                      Ehliyet Bilgileri
                    </h5>
                    
                    <Row>
                      <Col md={6}>
                        <FormGroup className="mb-3">
                          <Label className="text-muted fw-bold font-size-12 text-uppercase">Ehliyet Sınıfı</Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light"><i className="mdi mdi-format-list-bulleted text-muted"></i></span>
                            <Input 
                              type="text" 
                              placeholder="Örn: B, C, CE" 
                              className="fw-medium"
                              value={form.licenseClass} 
                              onChange={(e) => handleInputChange("licenseClass", e.target.value)} 
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-3">
                          <Label className="text-muted fw-bold font-size-12 text-uppercase">Ehliyet No</Label>
                          <div className="input-group">
                            <span className="input-group-text bg-light"><i className="mdi mdi-pound text-muted"></i></span>
                            <Input 
                              type="text" 
                              placeholder="Numara giriniz" 
                              className="fw-medium"
                              value={form.licenseNo} 
                              onChange={(e) => handleInputChange("licenseNo", e.target.value)} 
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* BELGE YÜKLEME */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody className="p-4">
                    <h5 className="card-title fw-bold mb-4 border-bottom pb-3">
                      <i className="mdi mdi-file-document-outline text-primary me-2 fs-4 align-middle"></i> 
                      Belge Yükleme
                    </h5>

                    <UploadItemRow label="Kimlik Fotoğrafı" fieldName="Identity_Url" />
                    <UploadItemRow label="Ehliyet Fotoğrafı" fieldName="License_Url" />
                    <UploadItemRow label="Adli Sicil Kaydı" fieldName="Criminalrecord_Url" />
                    <UploadItemRow label="Vergi Levhası" fieldName="Taxplate_Url" />
                    <UploadItemRow label="Çekici Sertifikası (İsteğe Bağlı)" fieldName="TowingCertificate" />
                    
                  </CardBody>
                </Card>

                {/* SÖZLEŞME VE ONAY */}
                <Card className="shadow-sm border rounded-4 border-primary">
                  <CardBody className="p-4 text-center">
                    
                    <a href="#" className="btn btn-soft-warning fw-bold mb-4 px-4 py-2">
                      <i className="mdi mdi-file-sign text-warning fs-5 align-middle me-2"></i> 
                      Sürücü Sözleşmesini Oku
                    </a>

                    <div className="d-flex justify-content-center align-items-center mb-4">
                      <div className="form-check form-switch form-switch-lg mb-0" dir="ltr">
                        <Input 
                          type="checkbox" 
                          className="form-check-input" 
                          id="contractSwitch" 
                          checked={form.contractAccepted}
                          onChange={(e) => handleInputChange("contractAccepted", e.target.checked)}
                        />
                        <Label className="form-check-label fw-bold text-dark ms-2 mt-1" htmlFor="contractSwitch">
                          Okudum, {isAdmin && targetUserId !== loggedInUserId?.toString() ? "yönetici olarak onaylıyorum." : "kabul ediyorum."}
                        </Label>
                      </div>
                    </div>

                    <div className="d-grid">
                      <Button color="primary" size="lg" className="fw-bold py-3 shadow" onClick={handleSubmit} disabled={actionLoading}>
                        {actionLoading ? <Spinner size="sm" color="light" className="me-2"/> : <i className="mdi mdi-check-decagram fs-5 align-middle me-2"></i>}
                        {isAdmin && targetUserId !== loggedInUserId?.toString() ? "BELGELERİ KAYDET" : "BAŞVURUYU TAMAMLA"}
                      </Button>
                    </div>

                  </CardBody>
                </Card>

              </Col>
            </Row>
          )}

        </Container>
      </div>
    </React.Fragment>
  );
};

export default SurucuBasvurusu;